import { Icon } from "@circle-react-shared/Icon";
import type { Filter } from "@circle-react-shared/Notifications/NotificationContext";
import {
  FILTERS,
  useNotificationContext,
} from "@circle-react-shared/Notifications/NotificationContext";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";
import { Dropdown } from "@circle-react-uikit/Dropdown";
import { useMemo } from "react";
import { useQueryClient } from "react-query";

import { t } from "@/i18n-js/instance";

interface DropdownOption {
  icon: string;
  label: string;
  value: Filter;
}

export const NotificationFilter = () => {
  const { activeFilter, setActiveFilter } = useNotificationContext();
  const queryClient = useQueryClient();
  const dropdownOptions: DropdownOption[] = useMemo(
    () => [
      {
        icon: "20-inbox",
        label: t("header_v3.filters.all"),
        value: FILTERS.ALL,
      },
      {
        icon: "20-inbox-unread",
        label: t("header_v3.filters.unread"),
        value: FILTERS.UNREAD,
      },
      {
        icon: "20-inbox-archived",
        label: t("header_v3.filters.archived"),
        value: FILTERS.ARCHIVED,
      },
    ],
    [],
  );

  const handleOnClick = (value: Filter) => {
    void queryClient.invalidateQueries({ queryKey: ["notifications", value] });
    setActiveFilter(value);
  };

  return (
    <Dropdown
      direction="bottom-end"
      menuButtonEl="div"
      button={
        <Dropdown.MenuButton id="action-block">
          <IconButton
            name="20-filter-v2"
            ariaLabel={t("header_v3.filters.title")}
            iconClassName="!text-dark"
            iconSize={20}
          />
        </Dropdown.MenuButton>
      }
    >
      {dropdownOptions.map((item: DropdownOption) => {
        const { value, icon, label } = item;
        return (
          <Dropdown.Item key={value} onClick={() => handleOnClick(value)}>
            <Dropdown.ItemLink
              type="button"
              active={activeFilter === value}
              aria-label={label}
            >
              <div className="flex items-center gap-x-2">
                <Icon type={icon} size={20} />
                <span>{label}</span>
              </div>
            </Dropdown.ItemLink>
          </Dropdown.Item>
        );
      })}
    </Dropdown>
  );
};
